<div class="box uv-side-panel">

    <div class="uv-side-panel-top-content">
        <ng-content select="[top]"></ng-content> 
    </div>

    <div class="divider"></div>

    <div class="uv-side-panel-bottom-content" 
    [class.scroll-wrapper]="scroll">
        <div 
        [class.scroll]="scroll" 
        [class.scroll-gradient]="scrollGradient">
            <ng-content select="[bottom]"></ng-content>
        </div>
    </div>

</div>
